import { Mixpanel } from 'utilities/mixpanel';

export function AddFreshChat() {
  // Freshchat into Summary Page
  if (typeof document !== 'undefined') {
    if (!window.fcSettings) {
      var _loaded = {};

      const addScript = url => {
        if (!_loaded[url]) {
          var s = document.createElement('script');
          s.src = url;
          document.head.appendChild(s);
          _loaded[url] = true;
        }
      };

      addScript('https://wchat.freshchat.com/js/widget.js');

      window.fcSettings = {
        token: '3fd36d09-4e1f-4a48-a97d-e78f3f1954ae',
        host: 'https://wchat.freshchat.com',
        config: {
          content: {
            headers: {
              channel_response: { offline: ' ' }
            }
          },
          headerProperty: {}
        }
      };
    }
    if (window.fcWidget) {
      window.fcWidget.on('widget:opened', function() {
        Mixpanel.track('Freshchat Opened');
      });
    }
  }
}
